import {
    FETCH_COMMISSION_RULES_REQUEST,
    FETCH_COMMISSION_RULES_SUCCESS,
    FETCH_COMMISSION_RULES_FAILURE,
    CREATE_COMMISSION_RULE_REQUEST,
    CREATE_COMMISSION_RULE_SUCCESS,
    CREATE_COMMISSION_RULE_FAILURE,
    UPDATE_COMMISSION_RULE_REQUEST,
    UPDATE_COMMISSION_RULE_SUCCESS,
    UPDATE_COMMISSION_RULE_FAILURE,
    DELETE_COMMISSION_RULE_REQUEST,
    DELETE_COMMISSION_RULE_SUCCESS,
    DELETE_COMMISSION_RULE_FAILURE,
} from "../actions/types";

const initialState = {
    commissionRules: [],
    loading: false,
    error: null,
    message: "",
};

export default function commissionRuleReducer(
    state = initialState,
    action
) {
    switch (action.type) {
        case FETCH_COMMISSION_RULES_REQUEST:
        case CREATE_COMMISSION_RULE_REQUEST:
        case UPDATE_COMMISSION_RULE_REQUEST:
        case DELETE_COMMISSION_RULE_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_COMMISSION_RULES_SUCCESS:
            return {
                ...state,
                loading: false,
                commissionRules: action.payload,
                message:
                    "Commission rules loaded successfully",
            };

        case CREATE_COMMISSION_RULE_SUCCESS:
            return {
                ...state,
                loading: false,
                commissionRules: [
                    ...state.commissionRules,
                    action.payload,
                ],
                message:
                    "Commission rule created successfully",
            };

        case UPDATE_COMMISSION_RULE_SUCCESS:
            return {
                ...state,
                loading: false,
                commissionRules:
                    state.commissionRules.map(
                        (rule) =>
                            rule.commission_rule_id ===
                            action.payload
                                .commission_rule_id
                                ? {
                                      ...rule,
                                      ...action.payload,
                                  }
                                : rule
                    ),
                message:
                    "Commission rule updated successfully",
            };

        case DELETE_COMMISSION_RULE_SUCCESS:
            return {
                ...state,
                loading: false,
                commissionRules:
                    state.commissionRules.filter(
                        (rule) =>
                            rule.commission_rule_id !==
                            action.payload
                    ),
                message:
                    "Commission rule deleted successfully",
            };

        case FETCH_COMMISSION_RULES_FAILURE:
        case CREATE_COMMISSION_RULE_FAILURE:
        case UPDATE_COMMISSION_RULE_FAILURE:
        case DELETE_COMMISSION_RULE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };

        default:
            return state;
    }
}